module.exports = __webpack_public_path__ + "assets/img/redses.cb02e373.png";